import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, ExternalLink } from "lucide-react";
import { FaTiktok, FaWhatsapp } from "react-icons/fa";
import CurrencySelector from "./CurrencySelector";

const Footer = () => {
  return (
    <footer className="bg-white border-t pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div className="mb-8 sm:mb-0 sm:col-span-2 md:col-span-1">
            <div className="mb-4 sm:text-left">
              <img 
                src="/lovable-uploads/bf2869c6-c7dd-4a46-a046-7189f9435aa3.png" 
                alt="JamPack'd Logo" 
                className="h-20 sm:h-28 md:h-32 w-auto sm:mx-0" 
              />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed sm:text-left mb-4">
              Bringing the vibrant flavours and culture of Jamaica right to your doorstep with our carefully curated care packages.
            </p>
            <div className="flex sm:justify-start space-x-3 mb-6">
              <a href="https://instagram.com/jampackdcarepackages" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-jamaica-green transition-colors p-2 rounded-full hover:bg-jamaica-green/5">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://tiktok.com/@jampackdcarepackages" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-jamaica-green transition-colors p-2 rounded-full hover:bg-jamaica-green/5">
                <FaTiktok className="h-5 w-5" />
              </a>
              <a href="https://wa.me/18763276630?text=Hi%20Paul%21%20I%27d%20appreciate%20your%20help%20with%20something" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-jamaica-green transition-colors p-2 rounded-full hover:bg-jamaica-green/5">
                <FaWhatsapp className="h-[20px] w-[20px]" />
              </a>
            </div>
          </div>
          
          <div className="sm:text-left">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-3 sm:mb-4 flex items-center">
              <span className="w-2 h-2 bg-jamaica-green rounded-full mr-2 sm:hidden"></span>
              Shop
            </h3>
            <ul className="space-y-2 ml-4 sm:ml-0">
              <li>
                <Link to="/products" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products/new" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link to="/products/best-sellers" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Best Sellers
                </Link>
              </li>
              <li>
                <Link to="/products/on-sale" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Special Offers
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="sm:text-left">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-3 sm:mb-4 flex items-center">
              <span className="w-2 h-2 bg-jamaica-yellow rounded-full mr-2 sm:hidden"></span>
              Company
            </h3>
            <ul className="space-y-2 ml-4 sm:ml-0">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/#newsletter" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Newsletter
                </Link>
              </li>
              <li>
                <Link to="/affiliate/signup" className="text-gray-600 hover:text-jamaica-green transition-colors">
                  Become an Affiliate
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="sm:text-left sm:col-span-2 md:col-span-1">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-3 sm:mb-4 flex items-center">
              <span className="w-2 h-2 bg-jamaica-green rounded-full mr-2 sm:hidden"></span>
              Contact Us
            </h3>
            <ul className="space-y-3 sm:space-y-2 ml-4 sm:ml-0">
              <li className="flex items-center sm:justify-start">
                <Mail className="h-4 w-4 mr-2 text-jamaica-green flex-shrink-0" />
                <a href="mailto:support@jampackd.store" className="text-gray-600 hover:text-jamaica-green transition-colors text-sm">
                  support@jampackd.store
                </a>
              </li>
              <li className="flex items-center sm:justify-start">
                <Phone className="h-4 w-4 mr-2 text-jamaica-green flex-shrink-0" />
                <a href="tel:+18763276630" className="text-gray-600 hover:text-jamaica-green transition-colors text-sm">
                  +1 (876) 327-6630
                </a>
              </li>
            </ul>
            
            <div className="mt-6 pt-4 border-t border-gray-100 sm:border-0 sm:pt-6">
              <h4 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-3 sm:text-left flex items-center">
                <span className="w-2 h-2 bg-jamaica-yellow rounded-full mr-2 sm:hidden"></span>
                Currency
              </h4>
              <div className="ml-4 sm:ml-0 sm:justify-start">
                <CurrencySelector />
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center md:text-left space-y-3 md:space-y-0">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} JamPack'd Care Packages. All rights reserved.
            </p>
            <a 
              href="https://www.paulsmith.codes" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-jamaica-green hover:text-jamaica-green/80 flex items-center md:justify-start transition-colors hover:underline"
            >
              Developed by PaulSmith.Codes <ExternalLink className="ml-1 h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
